import { useState } from "react";
import { downloadAttachment } from "@/api";

/**
 * Download button for one attachment of a task or trial (customer item 29): the file in full quality,
 * under its original filename. Shown beside each photo; a failed download shows a message with Retry.
 */
export default function AttachmentDownloadButton({ attachment, className = "" }) {
  const [state, setState] = useState("idle"); // idle | downloading | failed
  const name = attachment.original_filename || attachment.filename;

  const download = async () => {
    setState("downloading");
    try {
      await downloadAttachment(attachment);
      setState("idle");
    } catch {
      setState("failed");
    }
  };

  if (state === "failed") {
    return (
      <div role="alert" className={`flex flex-col items-center gap-1 text-xs text-red-700 dark:text-red-300 ${className}`}>
        <span>Download failed.</span>
        <button
          type="button"
          onClick={download}
          className="min-h-10 rounded border border-red-300 px-3 font-semibold hover:bg-red-100 dark:border-red-700 dark:hover:bg-red-900/40"
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={download}
      disabled={state === "downloading"}
      aria-label={`Download ${name}`}
      title={`Download ${name}`}
      className={`inline-flex min-h-10 items-center justify-center gap-1 rounded border border-emerald-600 px-3 text-xs font-semibold text-emerald-700 hover:bg-emerald-50 focus:outline-none focus:ring-2 focus:ring-emerald-400 disabled:opacity-60 dark:text-emerald-400 dark:hover:bg-emerald-950 ${className}`}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="h-4 w-4" aria-hidden="true">
        <path d="M10.75 2.75a.75.75 0 0 0-1.5 0v8.614L6.295 8.235a.75.75 0 1 0-1.09 1.03l4.25 4.5a.75.75 0 0 0 1.09 0l4.25-4.5a.75.75 0 0 0-1.09-1.03l-2.955 3.129V2.75Z" />
        <path d="M3.5 12.75a.75.75 0 0 0-1.5 0v2.5A2.75 2.75 0 0 0 4.75 18h10.5A2.75 2.75 0 0 0 18 15.25v-2.5a.75.75 0 0 0-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2.5Z" />
      </svg>
      {state === "downloading" ? "Downloading…" : "Download"}
    </button>
  );
}
